const PACKLIST_STATUS_PREFIX = 'PACKLIST_STATUS_'

const PENDING = '#db5800'
const IN_PROGRESS = '#1557bf'
const PACKED = '#7b4fd1'
const DISPATCHED = '#0e8f9e'
const DONE = '#2b8251'
const EXCEPTION = '#c10b3a'

// Shown for empty cells so a zero never reads as loudly as a real count.
export const DIM_COLOR = '#c3ccd1'

const STATUS_COLORS = {
  PENDING,
  PROCESSING: IN_PROGRESS,
  PICKING: IN_PROGRESS,
  PICKED: IN_PROGRESS,
  CHECKING: IN_PROGRESS,
  CHECKED: IN_PROGRESS,
  PACKING: IN_PROGRESS,
  PACKED,
  DISPATCHED,
  DELIVERED: DISPATCHED,
  COMPLETED: DONE,
  RECEIVED: DONE,
  CANCELLED: EXCEPTION,
  RETURNED: EXCEPTION,
  NOT_RECEIVED: EXCEPTION,
}

// Card background/border pairs for the pipeline tiles - a tint of the status colour,
// light enough to sit a large number on.
const STATUS_TINTS = {
  PENDING: { bg: '#fff8f3', border: '#ffe0c7' },
  PROCESSING: { bg: '#f4f8fe', border: '#d3e2f8' },
  PACKED: { bg: '#f8f5fe', border: '#e0d5f7' },
  DISPATCHED: { bg: '#f1fbfc', border: '#c9eaee' },
  COMPLETED: { bg: '#f2fbf6', border: '#cdeddb' },
  CANCELLED: { bg: '#fdf4f6', border: '#f5d3db' },
}

const NEUTRAL_TINT = { bg: '#fbfcfc', border: '#eef2f4' }

/**
 * Packlist statuses arrive prefixed (PACKLIST_STATUS_PENDING); order statuses do not.
 * Both share the same colour buckets once the prefix is off.
 */
export const stripStatusPrefix = (status = '') =>
  status.startsWith(PACKLIST_STATUS_PREFIX)
    ? status.slice(PACKLIST_STATUS_PREFIX.length)
    : status

export const getStatusColor = (status) =>
  STATUS_COLORS[stripStatusPrefix(status || '').toUpperCase()] || IN_PROGRESS

export const getStatusTint = (status) =>
  STATUS_TINTS[stripStatusPrefix(status || '').toUpperCase()] || NEUTRAL_TINT

export default STATUS_COLORS
